'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './adminStats.routes';
import { ISeason, ISeasonUtilsService, IOptionsService } from '../../interfaces';
import { IBasketStats } from './basketStatsInterface';

export class AdminStatsComponent {
    $http: ng.IHttpService;
    $stateParams: any;
    Season;
    SeasonUtils: ISeasonUtilsService;
    OptionsService: IOptionsService;

    seasons: ISeason[];
    selectedSeason: ISeason;

    totalQty: number;
    totalQtyFixedPrice: number;
    expectedIncome: number;
    totalFreeBaskets: number;
    averageFixedPrice: number;
    basketStats: IBasketStats[];

    constructor($http, $stateParams, Season, OptionsService, SeasonUtils: ISeasonUtilsService) {
        this.$http = $http;
        this.$stateParams = $stateParams;
        this.Season = Season;
        this.SeasonUtils = SeasonUtils;
        this.OptionsService = OptionsService;

        this.applySeason(() => {
            this.loadingStats();
        });
    }

    selectSeason(season) {
        this.selectedSeason = season;
        this.loadingStats();
    }

    private applySeason(callback) {
        let seasonId = this.$stateParams.seasonId;

        this.Season.query(seasons => {
            this.seasons = seasons;

            // When there is a season selected
            if (seasonId) {
                let seasonFound = this.seasons.find(
                    season => {
                        return season._id+'' === seasonId+'';
                    }
                );

                if (seasonFound) {
                    this.selectedSeason = seasonFound;
                    return callback();
                }
            }
        
            // When there is not a season selected or passed by parameters
            this.OptionsService.getActiveSeason()
            .then(activeSeason => {
                if (!activeSeason) {
                    // Return the latest season when there is not one active
                    this.selectedSeason =  this.seasons[this.seasons.length-1];
                } else {
                    this.selectedSeason =   activeSeason;
                }
                return callback();
            });
        });
    }

    loadingStats() {
        let scope = this;
        
        scope.$http.get('/api/stats/baskets/'+ scope.selectedSeason._id)
        .then(res => {
            let data: any = res.data;

            scope.totalQty = data.totalQty;
            scope.totalQtyFixedPrice = data.totalQtyFixedPrice;
            scope.totalFreeBaskets = data.totalFreeBaskets;
            scope.expectedIncome = data.expectedIncome;
            scope.averageFixedPrice = data.averageFixedPrice,
            scope.basketStats = data.baskets as IBasketStats[];
        });
    }
}

export default angular.module('terrappApp.adminStats', [uiRouter])
  .config(routes)
  .component('adminStats', {
    template: require('./adminStats.html'),
    controller: AdminStatsComponent,
    controllerAs: '$ctrl'
  })
  .name;


// WEBPACK FOOTER //
// ./client/app/admin/adminStats/adminStats.component.ts